// extracted by mini-css-extract-plugin
export var fadeIn = "MarketoForm-module--fade-in--19620";
export var fadeInForm = "MarketoForm-module--fadeInForm--97c33";
export var fadeOut = "MarketoForm-module--fade-out--361f2";
export var isNewDemo = "MarketoForm-module--is-new-demo--4190a MarketoForm-module--marketo-form--415fb";
export var marketoForm = "MarketoForm-module--marketo-form--415fb";
export var marketoFormSuccess = "MarketoForm-module--marketo-form-success--3b158";
export var rotate = "MarketoForm-module--rotate--c8c9b";
export var singleCol = "MarketoForm-module--single-col--e7e12 MarketoForm-module--marketo-form--415fb";
export var spinner = "MarketoForm-module--spinner--30cca";